import { FormattedMessage } from 'react-intl'
import { useMutation, useApolloClient, gql } from '@apollo/client'

import styled from 'styled-components'

import { getUnprocessableErrors } from 'utils/error'
import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { resolvers as insuranceResolvers, getTicketsToApplyInsurance } from 'resolvers/insurance'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`

const APPLY_TICKETS_INSURANCE = gql`
  mutation ApplyTicketsInsurance($bookingId: ID!, $ticketIds: [ID!]!) {
    addBookingTicketsInsurance(input: { id: $bookingId, ticketIDs: $ticketIds })
  }
`

const APPLY_LOCAL_TICKETS_INSURANCE = gql`
  mutation ApplyLocalTicketsInsurance($ticketIds: [ID!]!) {
    applyTicketsInsurance(ticketIds: $ticketIds) @client
  }
`

export const ApplyBookingInsuranceModal = ({ booking, closeModal }: TSFixMe): TSFixMe => {
  const client = useApolloClient()
  client.addResolvers(insuranceResolvers)

  const [applyLocalTicketsInsurance] = useMutation(APPLY_LOCAL_TICKETS_INSURANCE)
  const [applyTicketsInsurance, { loading, error }] = useMutation(APPLY_TICKETS_INSURANCE, {
    onCompleted() {
      applyLocalTicketsInsurance({
        variables: {
          ticketIds: getTicketsToApplyInsurance(booking.tickets).map(({ id }): TSFixMe => id)
        }
      })
      closeModal()
    }
  })

  const handleApplyInsurance = (): TSFixMe => {
    applyTicketsInsurance({
      variables: {
        bookingId: booking.id,
        ticketIds: getTicketsToApplyInsurance(booking.tickets).map(({ id }): TSFixMe => id)
      }
    })
  }

  return (
    <ModalContainer large>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage id="bookings.insurance.apply.title" defaultMessage="Apply insurance" />
        </Heading.H5>
      </Modal.Header>

      <Modal.Content>
        <div>
          <FormattedMessage
            id="bookings.insurance.apply.description"
            defaultMessage="Are you sure to apply the insurance for the whole booking?"
          />
        </div>
      </Modal.Content>

      <Modal.Footer>
        {error && (
          <Modal.ErrorMessage>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage
                id="bookings.insurance.apply.error"
                defaultMessage="There was an error while applying the insurance."
              />
            </ErrorMessage>
          </Modal.ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
            <FormattedMessage id="modal.actions.close" defaultMessage="No, close" />
          </Button>
          <Button kind="primary" loading={loading} onClick={handleApplyInsurance}>
            <FormattedMessage id="bookings.insurance.apply.action" defaultMessage="Apply insurance" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </ModalContainer>
  )
}
